import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Modal from '../componentes/Modal.jsx';
import Api from '../../utils/Api.jsx';
import LabeledInput from '../componentes/LabeledInput';

class ModalAlterarSenha extends React.Component {
  state = {
    senha_atual: '',
    nova_senha: '',
    confirmar_senha: '',
    status_validacao: {
      tamanho: false,
      letra: false,
      especial: false,
    },
    tipoSenha: {
      atual: true,
      nova: true,
      confirmar: true,
    },
  };

  validarSenha = (senha) => {
    const status_validacao = {
      tamanho: senha.length >= 8,
      letra: /[A-Za-z]/.test(senha),
      especial: /[^A-Za-z0-9]/.test(senha),
    };
    this.setState({ nova_senha: senha, status_validacao });
  };

  getColor = (status) => {
    return status ? 'green' : 'red';
  };

  toggleSenhaVisibilidade = (field) => {
    this.setState((prevState) => ({
      tipoSenha: {
        ...prevState.tipoSenha,
        [field]: !prevState.tipoSenha[field],
      },
    }));
  };

  async show() {
    this.modal.show();
    setTimeout(() => {
      if (this.inputSenhaAtual) {
        this.inputSenhaAtual.focus();
      }
    }, 500);
  }

  hideModal = () => {
    this.modal.hide();
  };

  async confirmar() {
    const { nova_senha, senha_atual, status_validacao, confirmar_senha } = this.state;

    const erros = [];
    if (!status_validacao.tamanho) erros.push('Senha muito pequena.');
    if (!status_validacao.letra) erros.push('Não contém letra.');
    if (!status_validacao.especial) erros.push('Não contém caractere especial.');
    if (nova_senha.trim() !== confirmar_senha.trim()) erros.push('As senhas não coincidem.');

    if (erros.length > 0) {
      toastr.error('Erro(s) de Validação:', erros.join(' '));
      return;
    }
    if (nova_senha.trim() !== senha_atual.trim()) {
      const r = await Api.setAlterarSenha(
        this.props.usuario.id || this.props.usuario.cod_usuario,
        nova_senha,
        senha_atual
      );

      if (!r.status) {
        toastr.error('Erro', r.erro.error_message);
        return;
      }
      this.modal.hide();
      this.setState({
        senha_atual: '',
        nova_senha: '',
        confirmar_senha: '',
        status_validacao: {
          tamanho: false,
          letra: false,
          especial: false,
        },
      });
      toastr.success('Senha alterada com sucesso');
    } else {
      toastr.error('A nova senha não pode ser igual à senha atual');
    }
  }

  render() {
    const botoes = [
      {
        icon: 'fa-times',
        label: 'Cancelar',
        onClick: this.hideModal.bind(this),
        className: 'btn-danger',
      },
      {
        icon: 'fa-check',
        label: 'Confirmar (F2)',
        onClick: this.confirmar.bind(this),
      },
    ];

    return (
      <Modal
        buttons={botoes}
        ref={(e) => (this.modal = e)}
        title="Alterar Senha"
        closeOnEsc
        confirmOnF2={() => this.confirmar()}
      >
        <LabeledInput
          label="Senha Atual:"
          value={this.state.senha_atual}
          type={this.state.tipoSenha.atual ? 'password' : 'input'}
          className="mb-10"
          uppercase="false"
          onChange={(e) => this.setState({ senha_atual: e.target.value })}
          onKeyEnter={() => this.inputNovaSenha.focus()}
          inputRef={(e) => (this.inputSenhaAtual = e)}
        />
        <i
          className={`fa ${this.state.tipoSenha.atual ? 'fa-eye' : 'fa-eye-slash'}`}
          onClick={() => this.toggleSenhaVisibilidade('atual')}
          style={{
            position: 'absolute',
            right: '25px',
            top: '16%',
            transform: 'translateY(-50%)',
            fontSize: '18px',
            cursor: 'pointer',
          }}
        />

        <LabeledInput
          label="Nova Senha:"
          value={this.state.nova_senha}
          type={this.state.tipoSenha.nova ? 'password' : 'input'}
          uppercase="false"
          className="mb-10"
          onChange={(e) => this.validarSenha(e.target.value)}
          onKeyEnter={() => this.inputConfirmarSenha.focus()}
          inputRef={(e) => (this.inputNovaSenha = e)}
        />
        <i
          className={`fa ${this.state.tipoSenha.nova ? 'fa-eye' : 'fa-eye-slash'}`}
          onClick={() => this.toggleSenhaVisibilidade('nova')}
          style={{
            position: 'absolute',
            right: '25px',
            top: '35%',
            transform: 'translateY(-50%)',
            fontSize: '18px',
            cursor: 'pointer',
          }}
        />

        <LabeledInput
          label="Confirmar Nova Senha:"
          value={this.state.confirmar_senha}
          type={this.state.tipoSenha.confirmar ? 'password' : 'input'}
          uppercase="false"
          onChange={(e) => this.setState({ confirmar_senha: e.target.value })}
          onKeyEnter={() => this.confirmar()}
          inputRef={(e) => (this.inputConfirmarSenha = e)}
        />
        <i
          className={`fa ${this.state.tipoSenha.confirmar ? 'fa-eye' : 'fa-eye-slash'}`}
          onClick={() => this.toggleSenhaVisibilidade('confirmar')}
          style={{
            position: 'absolute',
            right: '25px',
            top: '54%',
            transform: 'translateY(-50%)',
            fontSize: '18px',
            cursor: 'pointer',
          }}
        />

        <p className="mt-10">As senhas devem atender aos seguintes critérios:</p>
        <ul>
          <li style={{ color: this.getColor(this.state.status_validacao.tamanho) }}>
            Deve conter pelo menos 8 caracteres
          </li>
          <li style={{ color: this.getColor(this.state.status_validacao.letra) }}>
            Deve conter uma letra
          </li>
          <li style={{ color: this.getColor(this.state.status_validacao.especial) }}>
            Deve conter um caractere especial
          </li>
          <li
            style={{
              color: this.getColor(
                this.state.nova_senha.trim() === this.state.confirmar_senha.trim() &&
                this.state.nova_senha
              ),
            }}
          >
            As senhas são iguais
          </li>
        </ul>
      </Modal>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
  }),
  (dispatch) => ({ dispatch }),
  null,
  { withRef: true }
)(ModalAlterarSenha);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/ModalAlterarSenha.jsx